import React, { useState, useEffect, useRef } from "react";
import { If } from "react-condition";
import { officeLocations } from "../../../config";
import { useParams } from "react-router-dom";
import axios from "../../../services/axios";
import useAxios from "../../../hooks/useAxios";
import { ReactLoading } from "../../Dashboard/TinManagement/import";
import swal from "sweetalert";
import Preview from "./components/Preview";
import { Button, Image, message, Modal, Tooltip } from "antd";
import DocViewer from "@cyntler/react-doc-viewer";
import { CloseOutlined, DeleteOutlined, EyeOutlined } from "@ant-design/icons";
import useGetFile from "../../../hooks/useGetFile";
import { capitalizeSentence } from "../../CandidateDashboard/utils/commonFunctions";

function FileInput({
  onBlurHandler,
  data,
  defaultValue = null,
  isChild,
  cInfo,
  approve,
  hasChiledReadOnly,
  isInputFieldTouched,
  form,
  fillOcrData,
  errorInputs,
  getCandidateFormsList,
  getCandidateDetails,
  tokenType,
  formType,
  aiSettings,
}) {
  const files = form?.files || [];

  const foundFile = [...files].find(
    (ele) => data?.properties?.label === ele?.fieldname
  );
  const { id } = useParams();
  const token = localStorage.getItem(tokenType);
  const fileRef = useRef(null);
  const { getImage } = useGetFile(token);
  const [fileName, setFileName] = useState("");
  const [defValue, setDefValue] = useState("");
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const api = useAxios();
  const [viewFile, setViewFile] = useState(false);
  const [srcFile, setSrcFile] = useState(null);
  const [ext, setExt] = useState(null);
  const [element, setElement] = useState({
    type: "file",
    properties: {
      label: "Input Element",
      required: true,
    },
  });
  const [readOnly, setReadOnly] = useState(false);

  const [valid, setValid] = useState(false);

  useEffect(() => {
    if (cInfo) {
      const fileData = cInfo.files.filter((ele) => {
        return (
          ele.originalname === data.properties.value?.split("\\")[2] &&
          ele?.fieldname === data?.properties?.label
        );
      });
      setValid(fileData[0]?.invalid);
      setReason(fileData[0]?.rejectionReason);
    }
  }, [cInfo, data]);

  //set child to required by default -Lovejot(08-DEC-2022)
  useEffect(() => {
    console.log("CALLED USE EFFECT");
    let obj = { ...data };
    let arr = [];
    if (obj.extensions) {
      Object.keys(obj?.extensions).forEach((ele) => {
        if (ele === "pdf" && obj?.extensions[ele] === true) {
          arr.push(".pdf");
        } else if (ele === "jpg" && obj?.extensions[ele] === true) {
          arr.push(".jpg");
        } else if (ele === "jpeg" && obj?.extensions[ele] === true) {
          arr.push(".jpeg");
        } else if (ele === "docx" && obj?.extensions[ele] === true) {
          arr.push(".docx");
        } else if (ele === "png" && obj?.extensions[ele] === true) {
          arr.push(".png");
        } else if (ele === "mp4" && obj?.extensions[ele] === true) {
          arr.push(".mp4");
        }
      });
    }

    if (arr.length !== 0) {
      obj.properties.accept = arr.join(",");
      obj.properties.acceptArr = arr;
    }

    // if (isChild) {
    //   let obj = { ...data };
    //   obj.properties.required = true;
    // }

    setElement((prev) => ({ ...prev, ...obj }));

    // if (data?.properties?.label === "Phone Number") {
    //   if (data?.properties?.value && data?.properties?.value?.length !== 0) {
    //     setReadOnly(true);
    //   } else if (data?.properties?.label === "Email") {
    //     setReadOnly(false);
    //   } else {
    //     setReadOnly(false);
    //   }
    // } else if (data?.properties?.label === "Employee Referal ID") {
    //   if (data?.properties?.value && data?.properties?.value?.length !== 0) {
    //     setReadOnly(true);
    //   }
    // }

    //check prefilled field -Lovejot(07-DEC-2022)
    if (
      data?.disableField === true &&
      data?.properties?.value &&
      data?.properties?.value?.length !== 0 &&
      localStorage.getItem("user.role") !== "admin"
    ) {
      setReadOnly(true);
    } else {
      setReadOnly(false);
    }
  }, [data, isChild]);

  function kbToMb(kb) {
    return Number(kb / 1024).toFixed(2);
  }

  const uploadFileAndGetData = async (e) => {
    const file = e.target.files[0];
    const formData = new FormData();
    let isApiCall = false;
    let type = "";
    let key = "";
    if (element.properties.label === "Upload Cancelled Cheque") {
      formData.append("cancelCheque", file);
      formData.append("docType", "CancelCheque");
      isApiCall = true;
      type = "BankDetailsOCR";
      key = "cancelCheque";
    }

    if (element.properties.label === "Upload Blood group") {
      formData.append("candidateDoc", file);
      formData.append("docType", "BloodGroup");
      type = "cifOCR";
      isApiCall = true;
      key = "bloodGroup";
    }

    if (element.properties.label === "Upload Caste Certificate") {
      formData.append("candidateDoc", file);
      formData.append("docType", "Caste");
      type = "cifOCR";
      isApiCall = true;
      key = "casteCertificate";
    }

    if (element.properties.label === "Upload 10th Certificate") {
      formData.append("candidateDoc", file);
      formData.append("docType", "10th");
      type = "cifOCR";
      isApiCall = true;
      key = "tenthCertificate";
    }

    if (element.properties.label === "Upload 12th Certificate") {
      formData.append("candidateDoc", file);
      formData.append("docType", "12th");
      type = "cifOCR";
      isApiCall = true;
      key = "twelfthCertificate";
    }

    if (element.properties.label === "Upload Graduation Certificate") {
      formData.append("candidateDoc", file);
      formData.append("docType", "Graduate");
      type = "cifOCR";
      isApiCall = true;
      key = "graduationCertificate";
    }

    if (element.properties.label === "Upload Postgraduate Certificate") {
      formData.append("candidateDoc", file);
      formData.append("docType", "Post Graduate");
      type = "cifOCR";
      isApiCall = true;
      key = "postGraduationCertificate";
    }

    if (element.properties.label === "Appointment letter/Offer letter") {
      formData.append("candidateDoc", file);
      formData.append("docType", "OfferLetter");
      type = "ProfessionalExp";
      isApiCall = true;
      key = "appointmentLetter";
    }

    if (element.properties.label === "Experience Letter/Relieving Letter") {
      formData.append("candidateDoc", file);
      formData.append("docType", "ExpLetter");
      type = "ProfessionalExp";
      isApiCall = true;
      key = "experienceLetter";
    }

    if (
      element.properties.label ===
      "Salary slips or bank statement of last three months"
    ) {
      formData.append("candidateDoc", file);
      formData.append("docType", "SalarySlip");
      type = "ProfessionalExp";
      isApiCall = true;
      key = "salarySlips";
    }

    formData.append("fileName", element.properties.label);
    formData.append("form", id);
    formData.append(
      "response",
      JSON.stringify([
        {
          label: element.properties.label,
          value: e.target.value,
          element,
        },
      ])
    );

    if (!isApiCall || !form) return;

    try {
      setLoading(true);
      setError(null);
      fillOcrData({
        [key]: "",
      });
      const result = await api.put(
        `/candidatedocuments/${type}/${form?._id}`,
        formData,
        {
          tokenType: "candidate",
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const { response } = result?.data?.OCRDetails;

      if (aiSettings?.isActive) {
        if ("error" in response) {
          setError(response?.error);
          setFileName("");
        } else {
          message.success(`Document uploaded successfully`, 2);
        }
      } else {
        if ("error" in response) {
          setError(response?.error);
        }
        message.success(`Document uploaded successfully`, 2);
      }
      await getCandidateFormsList();
      
      fileRef.current.value = "";
    } catch (err) {
      console.error(err);
      setError(err?.response?.data?.error?.OCRDetails?.response?.error);
      fillOcrData({
        [key]:
          err?.response?.data?.error?.OCRDetails?.response?.error ||
          "Something went wrong",
      });
    } finally {
      setLoading(false);
    }
  };

  const deleteFileFromS3 = async () => {
    try {
      if (!foundFile) {
        message.error("File not found.");
        return;
      }

      setLoading(true);
      await api.post(
        `/candidate/deleteS3Files`,
        {
          key: foundFile?.fieldname,
          path: foundFile?.path,
          ...(formType === "Joining" ? { _id: form?._id } : { _id: form?._id }),
          formType,
        },
        {
          tokenType: tokenType === "user.token" ? "user" : "candidate",
        }
      );

      if (formType === "Joining") {
        await getCandidateDetails();
      }

      if (formType === "Document") {
        await getCandidateFormsList();
      }
      if (fileRef.current) {
        fileRef.current.value = "";
      }
      setFileName("");
      setViewFile(false);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const viewFileFromS3 = async () => {
    setSrcFile(null);
    setExt("");
    try {
      if (!foundFile) {
        message.error("File not found.");
        return;
      }
      setLoading(true);
      const file = await getImage(foundFile?.path);
      const _ext = foundFile?.path?.split(".")?.pop();
      setSrcFile(file);
      setExt(_ext);
      setViewFile(true);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const foundError = errorInputs?.find(
    (ele) => ele?.label === element?.properties?.label
  );

  const DISABLED =
    approve ||
    !element.editable ||
    (defValue && hasChiledReadOnly) ||
    element?.isPhotoRestrict;

  const FILENAME = (element?.properties?.value || "").split("\\").pop();

  return (
    <>
      {loading && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      <div
        className="form-group col-md-12 form-builder-element mb-3"
        style={{ position: "relative" }}
      >
        <label
          htmlFor=""
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: "10px ",
          }}
        >
          <div className="d-flex flex-wrap align-items-center">
            {element.properties.label}
            <If
              test={
                element.properties.required === true &&
                element?.isMandate === undefined
              }
            >
              <span style={{ color: "red" }}>*</span>{" "}
            </If>
            <span>
              ( Format -{element.properties.accept})(Size -{" "}
              {kbToMb(Number(element.properties.size))} MB)
            </span>
            {element.properties.value && (
              <>
                {!valid ? (
                  <span
                    className="d-flex justify-content-center align-items-center"
                    style={{ color: "#38E54D" }}
                  >
                    {" "}
                    &nbsp;- Completed
                  </span>
                ) : (
                  <span
                    className="d-flex justify-content-center align-items-center"
                    style={{ color: "red" }}
                  >
                    {" "}
                    - Rejected : {reason ? reason : "N/A"}{" "}
                  </span>
                )}
              </>
            )}
          </div>
        </label>
        <input
          style={{ display: "none" }}
          ref={fileRef}
          onBlur={onBlurHandler}
          id={element?.id}
          onChange={(e) => {
            const file = e.target.files[0]
            setFileName(file?.name || "");
            const ext = file?.name?.split(".").pop();
            const size = file?.size;

            if (![...element?.properties?.acceptArr]?.includes(`.${ext}`)) {
              return message.error(`This file format is not allowed.`);
            }

            if (!(size <= parseInt(element.properties.size) * 1024)) {
              return message.error(
                `File size must be less than or equal to ${kbToMb(
                  Number(element.properties.size)
                )} MB`
              );
            }

            if (isInputFieldTouched) {
              isInputFieldTouched();
            }
            if (form) {
              uploadFileAndGetData(e);
            }
          }}
          readOnly={
            data?.disableField &&
            data?.properties?.value?.length !== 0 &&
            localStorage.getItem("user.role") !== "admin"
              ? data?.disableField
              : readOnly
          }
          disabled={
            approve ||
            !element.editable ||
            (defValue && hasChiledReadOnly) ||
            element?.isPhotoRestrict
          }
          className={`form-control form-view ${
            foundError || error ? "border border-danger" : ""
          }`}
          type="file"
          accept={element.properties.accept}
          defaultValue={
            defValue && isChild ? defValue : element.properties.value
          }
          label={element.properties.label}
          data={JSON.stringify(element)}
          pattern={element.properties.dataType}
        />
        <div className="d-flex" style={{ gap: 10 }}>
          <button
            data-testid = {element.properties.label}
            onClick={() => {
              fileRef.current.click();
            }}
            disabled={DISABLED}
            style={{
              border: `1px solid ${foundError || error ? "red" : "#d1d3e2"}`,
              padding: "10px 7px",
              width: "100%",
              textAlign: "left",
              outline: "none",
              background: `${DISABLED ? "#8080801f" : "none"}`,
              borderRadius: "0.35rem",
              display: "flex",
              alignItems: "center",
            }}
          >
            <span
              style={{
                padding: "3px 10px",
                border: "1px solid grey",
                background: "#80808026",
              }}
            >
              Choose File
            </span>
            <span
              style={{
                marginLeft: "10px",
                maxWidth: "100px", // set width for ellipsis
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "inline-block", // required for width control
              }}
            >
              {element?.properties?.value || fileName
                ? fileName || FILENAME || ""
                : "No file chosen"}
            </span>
          </button>
          {element.properties.value && (
            <>
              <div
                className="d-flex"
                style={{
                  gap: "10px",
                  flex: "1 1",
                  justifyContent: "flex-start",
                  marginTop: 5,
                }}
              >
                <Tooltip placement="top" title={"Preview"}>
                  <Button
                    onClick={(e) => viewFileFromS3()}
                    className="d-flex justify-content-center align-items-center text-primary p-2"
                  >
                    <EyeOutlined />
                  </Button>
                </Tooltip>
                {!approve && (
                  <Tooltip placement="top" title={"Delete"}>
                    <Button
                      onClick={(e) => {
                        swal({
                          title: "Are you sure?",
                          text: "Are you sure that you want to remove this file?",
                          icon: "warning",
                          dangerMode: true,
                          buttons: true,
                        }).then((willDelete) => {
                          if (willDelete) {
                            deleteFileFromS3();
                          }
                        });
                      }}
                      className="d-flex justify-content-center align-items-center text-danger p-2"
                    >
                      <DeleteOutlined />
                    </Button>
                  </Tooltip>
                )}
              </div>
            </>
          )}
        </div>
        {(error || foundError) && (
          <p className="text-danger">{capitalizeSentence(error) || foundError?.value}</p>
        )}
      </div>
      <Modal
        title=""
        className="p-0 custom_modal__"
        centered
        open={viewFile}
        width={600}
        closeIcon={
          <CloseOutlined style={{ color: "white", fontSize: "16px" }} />
        }
        footer={null}
        onCancel={() => {
          setViewFile(false);
        }}
      >
        <div>
          <div className="modal-header d-flex justify-content-between align-items-center active-color-modal text-white w-100">
            <h5
              className="modal-title text-white text-capitalize font-weight-bold"
              style={{ fontSize: "18px", fontWeight: 400 }}
            >
              Preview Document
            </h5>
          </div>
          <div className="p-2">
            <div className="d-flex justify-content-end">
              {!approve && (
                <Button
                  onClick={(e) => {
                    swal({
                      title: "Are you sure?",
                      text: "Are you sure that you want to remove this file?",
                      icon: "warning",
                      dangerMode: true,
                      buttons: true,
                    }).then((willDelete) => {
                      if (willDelete) {
                        deleteFileFromS3();
                      }
                    });
                  }}
                  className="d-flex justify-content-center align-items-center text-danger p-2 mb-2"
                >
                  Delete <DeleteOutlined />
                </Button>
              )}
            </div>
            {(ext?.toLowerCase() === "png" ||
              ext?.toLowerCase() === "jpeg" ||
              ext?.toLowerCase() === "jpg" ||
              ext?.toLowerCase() === "jfif") && (
              <div>
                <Image
                  width={null}
                  alt="img"
                  loading="Loading...."
                  src={srcFile}
                />
              </div>
            )}
            {ext?.toLowerCase() === "mp4" && (
              <div>
                <video
                  src={srcFile}
                  style={{
                    border: "1px solid black",
                    objectFit: "cover",
                    width: "100%",
                  }}
                  controls
                ></video>
              </div>
            )}

            {ext?.toLowerCase() === "pdf" && (
              <iframe
                style={{ width: "100%" }}
                title="iframe"
                className="iframe"
                width="100%"
                height="470"
                src={srcFile}
              >
                <p>iframes are not supported by your browser.</p>
              </iframe>
            )}
            {(ext?.toLowerCase() === "doc" ||
              ext?.toLowerCase() === "docx") && (
              <div style={{ flexGrow: 1 }} className="resume">
                <DocViewer
                  style={{ width: "100%" }}
                  config={{
                    header: {
                      disableHeader: true,
                      disableFileName: true,
                    },
                  }}
                  documents={[
                    {
                      uri: srcFile,
                      fileType: ext,
                    },
                  ]}
                />
              </div>
            )}
          </div>
        </div>
      </Modal>
    </>
  );
}

export default FileInput;
